import {makeObservable, observable, computed, action} from "mobx";

import {BaseWidgetDisplayModel} from "../../models/base-widget-display-model";
import type {EntityDescriptionFaqElementViewModel} from "../../../modules/entity-description-module/models/entity-description.faq.element.view-model";

export class AppFaqDisplayModel extends BaseWidgetDisplayModel {
  @observable elements: Array<EntityDescriptionFaqElementViewModel>;

  constructor() {
    super();

    this.elements = [];


    makeObservable(this);
  }

  @action updateElements(elements) {
    this.elements = elements
  }

  @computed get hasElements() {
    return this.elements?.length > 0
  }
}
